import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const scrollToElementWithOffset = (
  elementId: string,
  offset: number = 200,
) => {
  const element = document.getElementById(elementId);

  if (!element) {
    return;
  }

  const elementPosition = element.getBoundingClientRect().top + window.scrollY;
  const offsetPosition = elementPosition - offset;

  window.scrollTo({
    top: offsetPosition < 0 ? 0 : offsetPosition,
    behavior: 'smooth',
  });
};

export const useHashScroll = () => {
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash?.slice(1);

    if (!hash) {
      return;
    }

    const timeout = setTimeout(() => scrollToElementWithOffset(hash), 200);

    return () => {
      clearTimeout(timeout);
    };
  }, [location.hash]);
};
